import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, setLogLevel } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaEnterpriseProvider, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Inicializa o Firebase App
const app = initializeApp(firebaseConfig);

// Serviços que usaremos no app
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  // Melhora compatibilidade em ambientes com proxies e bundlers
  experimentalForceLongPolling: true,
  useFetchStreams: false,
});
const recaptchaEnterpriseKey = (import.meta.env.VITE_RECAPTCHA_ENTERPRISE_KEY as string) || '';
const recaptchaV3Key = (import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY as string) || '';
try { if (import.meta.env.DEV) { (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true; } } catch { }
try {
  if (recaptchaEnterpriseKey) {
    initializeAppCheck(app, { provider: new ReCaptchaEnterpriseProvider(recaptchaEnterpriseKey), isTokenAutoRefreshEnabled: true });
  } else if (recaptchaV3Key) {
    initializeAppCheck(app, { provider: new ReCaptchaV3Provider(recaptchaV3Key), isTokenAutoRefreshEnabled: true });
  }
} catch { }
const projectId = (import.meta.env.VITE_FIREBASE_PROJECT_ID as string) || '';
const configuredBucket = (import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string) || '';
const fallbackBucket = projectId ? `${projectId}.appspot.com` : '';
const hasDomain = configuredBucket.includes('appspot.com') || configuredBucket.includes('firebasestorage.app');
const bucketName = !configuredBucket
  ? fallbackBucket
  : hasDomain
    ? configuredBucket
    : `${configuredBucket}.appspot.com`;
const bucketUrl = bucketName ? `gs://${bucketName}` : undefined;
export const storage = bucketUrl ? getStorage(app, bucketUrl) : getStorage(app);
const useEmulator = String(import.meta.env.VITE_USE_STORAGE_EMULATOR || '').toLowerCase() === 'true';
if (useEmulator) {
  try { connectStorageEmulator(storage, 'localhost', Number(import.meta.env.VITE_STORAGE_EMULATOR_PORT || 9199)); } catch { }
}

// Reduz verbosidade de logs do Firestore no console
setLogLevel('silent');

export default app;
